import { Identifiable } from './identifiable';
import { Contact } from './contact';

export class AssessmentDistributionMemberData implements Identifiable {
  id: string;
  member: Contact;
  deletedPersonnelRecord: Contact;
  totalAnswered: string;
  riskCompleted: boolean;
}
